"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _ModalOverlay = require("../../components/Modal/ModalOverlay");
var _Popover = require("../../components/Popover/Popover.styles");
var _PortalBase = _interopRequireDefault(require("../../components/PortalBase"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _environmentCharacteristics = require("../../utils/environmentCharacteristics");
var _isAnimation = require("../../utils/isAnimation");
var _omit = _interopRequireDefault(require("../../utils/omit"));
var _splitCommonFromProps9 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _warning = _interopRequireDefault(require("../../utils/warning"));
var _excluded = ["children", "className", "closeOnClick", "openOnClick", "container", "disableAnimation", "disableOpenOnHover", "onMouseLeave", "onBlurClick", "onClick", "open", "overlayRef", "overrides", "staticPosition", "style", "targetId", "hideTriangle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */ /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var isFixedPosition = function isFixedPosition(el) {
  if (el.nodeName.toLowerCase() === "body") {
    return false;
  }
  if (window.getComputedStyle(el).position.toLowerCase() === "fixed") {
    return true;
  }
  if (!el.parentElement) {
    return false;
  }
  return isFixedPosition(el.parentElement);
};
var MAX_HEIGHT_VALUE = "90vh";
var MAX_HEIGHT_MULTIPLIER = 0.9;
var Popover = function Popover(props) {
  var _splitCommonFromProps = (0, _splitCommonFromProps9.default)(props, _Popover.popoverCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    common = _splitCommonFromProps2[0],
    _splitCommonFromProps3 = _splitCommonFromProps2[1],
    children = _splitCommonFromProps3.children,
    className = _splitCommonFromProps3.className,
    closeOnClick = _splitCommonFromProps3.closeOnClick,
    openOnClick = _splitCommonFromProps3.openOnClick,
    _splitCommonFromProps4 = _splitCommonFromProps3.container,
    container = _splitCommonFromProps4 === void 0 ? _environmentCharacteristics.isBrowser ? document.body : undefined : _splitCommonFromProps4,
    _splitCommonFromProps5 = _splitCommonFromProps3.disableAnimation,
    disableAnimation = _splitCommonFromProps5 === void 0 ? false : _splitCommonFromProps5,
    _splitCommonFromProps6 = _splitCommonFromProps3.disableOpenOnHover,
    disableOpenOnHoverProp = _splitCommonFromProps6 === void 0 ? false : _splitCommonFromProps6,
    onMouseLeave = _splitCommonFromProps3.onMouseLeave,
    onBlurClick = _splitCommonFromProps3.onBlurClick,
    onClick = _splitCommonFromProps3.onClick,
    open = _splitCommonFromProps3.open,
    overlayRef = _splitCommonFromProps3.overlayRef,
    _splitCommonFromProps7 = _splitCommonFromProps3.overrides,
    overrides = _splitCommonFromProps7 === void 0 ? {} : _splitCommonFromProps7,
    staticPosition = _splitCommonFromProps3.staticPosition,
    style = _splitCommonFromProps3.style,
    targetId = _splitCommonFromProps3.targetId,
    _splitCommonFromProps8 = _splitCommonFromProps3.hideTriangle,
    hideTriangle = _splitCommonFromProps8 === void 0 ? false : _splitCommonFromProps8,
    otherProps = _objectWithoutProperties(_splitCommonFromProps3, _excluded);
  var disableOpenOnHover = openOnClick || disableOpenOnHoverProp;
  var _useState = (0, _react.useState)(MAX_HEIGHT_VALUE),
    _useState2 = _slicedToArray(_useState, 2),
    contentMaxHeight = _useState2[0],
    setContentMaxHeight = _useState2[1];
  var theme = (0, _reactJss.useTheme)();
  var classes = (0, _Popover.usePopoverStyles)(_Popover.popoverVars.useVars(_objectSpread(_objectSpread({}, common), {}, {
    maxHeight: contentMaxHeight
  })));
  var rootStyle = (0, _Popover.usePopoverStyles)(_Popover.rootVars.useVars({
    background: props.background
  }));
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isVisible = _useState4[0],
    setIsVisible = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isExited = _useState8[0],
    setIsExited = _useState8[1];
  var nullRender = Boolean(!isVisible && isExited && !isOpen);
  var rootRef = (0, _react.useRef)(null);
  var targetRef = (0, _react.useRef)(null);
  var styleRef = (0, _react.useRef)({
    anchor: "left",
    trianglePosition: "top",
    triangleMargin: 0,
    resizeTimer: null,
    styles: {}
  });
  var filteredProps = (0, _omit.default)(["onFocus", "background"], otherProps);
  var _React$useState = _react.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isTargetBottom = _React$useState2[0],
    setIsTargetBottom = _React$useState2[1];
  var handleAnimations = function handleAnimations(event) {
    if (!_environmentCharacteristics.isBrowser) {
      return undefined;
    }
    if (event.type === "animationstart") {
      if ((0, _isAnimation.isAnyAnimation)(event, ["simpleOpen", "rootOpen"])) {
        if (!staticPosition) {
          window.addEventListener("resize", handleResize);
        }
        setIsVisible(true);
        setIsExited(false);
      }
    } else {
      if ((0, _isAnimation.isAnyAnimation)(event, ["simpleClose", "rootClose"])) {
        styleRef.current.styles = {};
        styleRef.current.anchor = "left";
        styleRef.current.trianglePosition = "top";
        targetRef.current.removeEventListener("mouseleave", handleMouseLeave);
        window.removeEventListener("resize", handleResize);
        setIsVisible(false);
        setIsExited(true);
      }
    }
  };
  var handlePosition = (0, _react.useCallback)(function () {
    if (!targetRef.current || !_environmentCharacteristics.isBrowser) {
      return undefined;
    }
    var targetRect = targetRef.current.getBoundingClientRect();
    var offsetWidth = document.body.offsetWidth;
    var marginOffset = theme.spacing.base;
    var triangleOffset = theme.spacing.base * 4 + 12;
    var targetX = targetRect.left + targetRect.width / 2;
    var targetWidthHalf = targetRect.width / 2;
    var windowWidthHalf = window.innerWidth / 2;
    var windowHeightHalf = document.documentElement.clientHeight / 2;
    var right = "auto";
    var left = "auto";
    var bottom;
    setIsTargetBottom(false);
    var anchor = "left";
    var scrollY = window.scrollY;
    var isFixed = isFixedPosition(targetRef.current);
    if (isFixed) {
      scrollY = 0;
    }
    if (windowHeightHalf < targetRect.top) {
      styleRef.current.trianglePosition = "bottom";
      bottom = (targetRect.top + scrollY - document.documentElement.clientHeight) * -1;
      setIsTargetBottom(true);
      setContentMaxHeight("".concat(targetRect.top * MAX_HEIGHT_MULTIPLIER, "px"));
    } else {
      styleRef.current.trianglePosition = "top";
      setContentMaxHeight("calc(".concat(MAX_HEIGHT_VALUE, " - ").concat(targetRect.top, "px)"));
    }
    anchor = windowWidthHalf < targetX ? "right" : "left";
    styleRef.current.anchor = anchor;
    if (anchor === "right") {
      right = offsetWidth - targetRect.left - targetWidthHalf - triangleOffset - marginOffset;
      if (right < 0) {
        styleRef.current.triangleMargin = right;
        right = 0;
      } else {
        styleRef.current.triangleMargin = 0;
      }
    }
    if (anchor === "left") {
      left = targetRect.left + targetWidthHalf - triangleOffset + window.scrollX - marginOffset;
      if (left < 0) {
        styleRef.current.triangleMargin = left;
        left = 0;
      } else {
        styleRef.current.triangleMargin = 0;
      }
    }
    return _objectSpread({
      top: bottom !== undefined ? "unset" : targetRect.top + targetRect.height + scrollY,
      bottom: bottom !== undefined ? bottom : "unset",
      // eslint-disable-next-line @atg/css-rtl-support
      left: left,
      // eslint-disable-next-line @atg/css-rtl-support
      right: right,
      flexDirection: bottom !== undefined ? "column-reverse" : "column",
      position: isFixed ? "fixed" : "absolute"
    }, style);
  }, [style, theme.spacing.base]);
  var handleFocus = function handleFocus(event) {
    if (!rootRef.current || !_environmentCharacteristics.isBrowser) {
      return undefined;
    }
    var currentHoverTargets = document.querySelectorAll(":hover");
    var specificTarget = currentHoverTargets[currentHoverTargets.length - 1];
    if (!rootRef.current.contains(specificTarget) && rootRef.current.contains(document.activeElement)) {
      setIsOpen(false);
    }
    if (otherProps.onFocus) {
      otherProps.onFocus(event);
    }
  };
  var handleResize = (0, _react.useCallback)(function () {
    // debounce so render only triggers when done resizing
    clearTimeout(styleRef.current.resizeTimer);
    styleRef.current.resizeTimer = setTimeout(function () {
      styleRef.current.styles = handlePosition();
      // have to trigger another render to reflect adjustment
      setIsOpen(isOpen);
    }, 100);
  }, [handlePosition, isOpen]);
  var checkRefForTargets = function checkRefForTargets(ref, event) {
    return ref.current !== event.target && ref.current !== event.relatedTarget && !ref.current.contains(event.target) && !ref.current.contains(event.relatedTarget);
  };
  var handleMouseLeave = (0, _react.useCallback)(function (e) {
    if (targetRef.current && rootRef.current) {
      var event = e.nativeEvent ? e.nativeEvent : e;
      var notRoot = checkRefForTargets(rootRef, event);
      var notTarget = checkRefForTargets(targetRef, event);
      var selectTarget = event.target.tagName === "SELECT" && rootRef.current.contains(event.target);
      if (notRoot || notTarget) {
        if (!selectTarget) {
          setIsOpen(false);
          if (disableAnimation) {
            setIsVisible(false);
            setIsExited(true);
          }
        }
      }
    }
    if (onMouseLeave && e.nativeEvent) {
      onMouseLeave(e);
    }
  }, [onMouseLeave, disableAnimation]);
  var handleMouseEnter = (0, _react.useCallback)(function () {
    if (!staticPosition) {
      styleRef.current.styles = handlePosition();
    }
    setIsOpen(true);
    targetRef.current.addEventListener("mouseleave", handleMouseLeave);
    targetRef.current.removeEventListener("mouseenter", handleMouseEnter);
  }, [handleMouseLeave, handlePosition, staticPosition]);
  var handleMouseClick = (0, _react.useCallback)(function () {
    if (!staticPosition) {
      styleRef.current.styles = handlePosition();
    }
    setIsOpen(true);
    targetRef.current.removeEventListener("mousedown", handleMouseClick);
  }, [handlePosition, staticPosition]);
  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
    if (closeOnClick) {
      setIsOpen(false);
    }
  };
  var handleBlur = function handleBlur() {
    return !openOnClick || setIsOpen(false);
  };
  var handleOverlayClick = function handleOverlayClick(event) {
    event.stopPropagation();
    if (onBlurClick) {
      onBlurClick();
    }
    if (openOnClick) {
      setIsOpen(false);
    }
  };
  (0, _react.useEffect)(function () {
    var target = targetRef;
    var targetElement = target.current ? target.current : document.querySelectorAll("#".concat(targetId));
    if (isOpen && targetElement.length > 1) {
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, "Multiple elements of the provided ID exist. Please use a unique ID.") : void 0;
      return;
    }
    if (isOpen && targetElement.length < 1) {
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, "The provided ID belongs to an element that either does not exist or is not yet rendered. The Popover component needs a valid element to attach to.") : void 0;
      return;
    }
    if (target.current === null) {
      target.current = targetElement[0];
    }
    if (!isOpen && isExited && !isVisible && target.current) {
      if (!disableOpenOnHover) {
        target.current.addEventListener("mouseenter", handleMouseEnter);
      } else if (openOnClick) {
        target.current.addEventListener("mousedown", handleMouseClick);
      }
    }
    if (!isOpen && !isExited && !isVisible) {
      // handling closing/debouncing(ish) for quick mouseovers
      styleRef.current.styles = {};
      styleRef.current.anchor = "left";
      styleRef.current.trianglePosition = "top";
      window.removeEventListener("resize", handleResize);
      target.current.removeEventListener("mouseleave", handleMouseLeave);
      setIsExited(true);
    }
    if (open !== undefined && open !== isOpen) {
      if (!staticPosition && !isVisible) {
        styleRef.current.styles = handlePosition();
      }
      setIsOpen(open);
    }
  }, [handleMouseEnter, handleMouseLeave, targetId, open, handlePosition, disableOpenOnHover, handleResize, staticPosition, isVisible, isOpen, isExited, openOnClick, handleMouseClick]);
  var rootClasses = (0, _classnames.default)(rootStyle.rootVariables, classes.root, _defineProperty({}, classes.rootOpen, isOpen && !isTargetBottom && !overrides.rootOpen), _defineProperty({}, classes.rootOpenBottom, isOpen && isTargetBottom && !overrides.rootOpen), _defineProperty({}, classes.rootClose, !isOpen && isVisible && !isTargetBottom && !overrides.rootClosed), _defineProperty({}, classes.rootCloseTop, !isOpen && isVisible && isTargetBottom && !overrides.rootClosed), _defineProperty({}, classes.simpleOpen, disableAnimation && isOpen && !overrides.rootOpen), _defineProperty({}, classes.simpleClose, disableAnimation && !isOpen && isVisible && !overrides.rootClosed), overrides.root, className);
  var triangleClasses = !staticPosition && !hideTriangle ? (0, _classnames.default)([classes.triangle], classes["".concat(styleRef.current.trianglePosition, "Triangle")], [overrides.triangle]) : "";
  var triangleStyle = {
    // eslint-disable-next-line @atg/css-rtl-support
    marginLeft: styleRef.current.anchor === "left" ? Math.max(theme.spacing.base * 4 + styleRef.current.triangleMargin, 0) : "auto",
    // eslint-disable-next-line @atg/css-rtl-support
    marginRight: styleRef.current.anchor === "right" ? Math.max(theme.spacing.base * 4 + styleRef.current.triangleMargin, 0) : "auto",
    marginBottom: -1,
    marginTop: -1
  };
  return !nullRender && /*#__PURE__*/_react.default.createElement(_PortalBase.default, {
    container: container
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: rootRef,
    style: styleRef.current.styles,
    onFocus: handleFocus,
    onClick: handleClick,
    onBlur: handleBlur,
    onMouseLeave: isOpen && isVisible && !disableOpenOnHover ? handleMouseLeave : undefined,
    onAnimationEndCapture: handleAnimations,
    onAnimationStart: handleAnimations,
    className: rootClasses
  }, filteredProps), /*#__PURE__*/_react.default.createElement("span", {
    className: triangleClasses,
    style: triangleStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.variables, classes.content, classes.scroll, overrides.content)
  }, children)), (onBlurClick || openOnClick) && /*#__PURE__*/_react.default.createElement(_ModalOverlay.ModalOverlay, {
    className: (0, _classnames.default)(classes.overlay, overrides.overlay),
    onClick: handleOverlayClick,
    ref: overlayRef,
    "data-ta-locator": "PopoverOverlay"
  })));
};
Popover.displayName = "Popover";
var Storybook = exports.Storybook = Popover;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/overlay-popover--docs
 */
var exportedComponent = (0, _defaultProps.default)(Popover);
exportedComponent.displayName = "Popover";
var _default = exports.default = exportedComponent;